import { Component, ErrorInfo } from 'react'

export default class ErrorBoundary extends Component<ErrorBoundaryType> {

    componentDidCatch(error: Error, errorInfo: ErrorInfo){
        this.props.onCatch(error, errorInfo)
    }

    render() {
        return this.props.children
    }
}

export type ErrorBoundaryType = {
    /** Callback when component did catch */
    onCatch: (error: Error, errorInfo: ErrorInfo) => void
}

